<vectronic-filter-header
  [title]="title()"
  [showToggle]="!hideToggle()"
  (titleClicked)="hideToggle() ? null : toggled.emit()"
  (enabledFilterToggle)="hideToggle() ? null : toggled.emit()"
  [isFilterEnabled]="hideToggle() || expanded()"
></vectronic-filter-header>

<div class="integer-filter" [hidden]="!hideToggle() && !expanded()">
  <div class="d-flex">
    <mat-form-field
      appearance="outline"
      [class.flex-grow-1]="!options()?.units"
      [style.width]="options()?.units ? '160px' : '100%'"
    >
      @if (options()?.prefix) {
        <span matTextPrefix>{{ options()?.prefix }}&nbsp;</span>
      }
      <input
        matInput
        type="number"
        [min]="options()?.min"
        [max]="options()?.max"
        [value]="displayValue"
        (input)="onInputChange($event)"
      />
      @if (options()?.suffix) {
        <span matTextSuffix>&nbsp;{{ options()?.suffix }}</span>
      }
    </mat-form-field>

    @if (options()?.units) {
      <mat-form-field appearance="outline" class="flex-grow-1">
        <mat-label>Unit</mat-label>
        <mat-select [value]="selectedFactor()" (selectionChange)="onUnitChange($event)">
          @for (unit of options()?.units; track unit.label) {
            <mat-option [value]="unit.factor">{{ unit.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
</div>
